import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import "./uploadFields.css";

const CSingleFileUpload = (props) => {
  const labelName = props.labelName;
  const name = props.name;
  const defaultvalue =
    props.defaultvalue !== undefined ? props.defaultvalue : "";
  const isPreviewImage = props.isPreviewImage === true ? true : false;
  const required = props.required === true ? true : false;
  const hidden = props.hidden === true ? true : false;
  const disabled = props.disabled === true ? true : false;
  const fileInputCustomStyle =
    props.fileInputCustomStyle === undefined ? {} : props.fileInputCustomStyle;
  const fileLabelCustomStyle =
    props.fileLabelCustomStyle === undefined ? {} : props.fileLabelCustomStyle;
  const previewLabelCustomStyle =
    props.previewLabelCustomStyle === undefined
      ? {}
      : props.previewLabelCustomStyle;
  const previewImgCustomStyle =
    props.previewImgCustomStyle === undefined
      ? {}
      : props.previewImgCustomStyle;
  const customClassLabel =
    props.customClassLabel === undefined ? "" : props.customClassLabel;
  const customClassInput =
    props.customClassInput === undefined ? "" : props.customClassInput;
  const customClassDiv =
    props.customClassDiv === undefined ? "" : props.customClassDiv;

  const [errorMsg, setErrorMsg] = useState("");
  const [isValid, setIsValid] = useState("");
  const [previewImage, setPreviewImage] = useState("");
  const [errClass, setErrClass] = useState("text-muted");
  const [placeholderColor, setPlaceholderColor] = useState("placeholderClr");

  const acceptListArray =
    props.acceptListArray === undefined
      ? ["application/pdf"]
      : props.acceptListArray;

  const setImage = (file) => {
    const fileType = acceptListArray.indexOf(file.type);
    if (fileType !== -1) {
      if (file.size > 2097152) {
        setIsValid("is-invalid");
        setErrorMsg("File size should be less than 2mb");
        setPlaceholderColor("");
        setErrClass("border border-danger text-danger");
      } else {
        setPlaceholderColor("");
        setErrClass("text-muted");
        setErrorMsg("");
        setIsValid("");
        props.functionName(name, file);
        setPreviewImage(URL.createObjectURL(file));
      }
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Check valid file type");
      setPlaceholderColor("");
      setErrClass("border border-danger text-danger");
    }
  };

  const checkRequired = (data) => {
    if (data !== undefined) {
      setErrorMsg("");
      setIsValid("");
      setImage(data);
    } else {
      setIsValid("is-invalid");
      setErrorMsg("Please fill this field");
    }
  };

  return (
    <>
      <div className={customClassDiv}>
        <div>
          <label
            className={`form-label ${customClassLabel}`}
            style={fileLabelCustomStyle}
          >
            {labelName}
          </label>
          <div className="input-group">
            <input
              name={name}
              className={`form-control border-end-0 ${customClassInput} ${placeholderColor} ${isValid}`}
              style={fileInputCustomStyle}
              type="file"
              accept={acceptListArray}
              required={required}
              disabled={disabled}
              hidden={hidden}
              onChange={(event) => {
                required === true
                  ? checkRequired(event.target.files[0])
                  : setImage(event.target.files[0]);
              }}
            />
            <span
              className={`input-group-text bg-primary-soft border-start-0 ${errClass}`}
            >
              <FontAwesomeIcon icon={faPaperclip} />
            </span>
          </div>

          {defaultvalue !== "" ? (
            <>
              <span>You already uploaded - </span>{" "}
              <span className="text-primary">{defaultvalue}</span>
            </>
          ) : (
            ""
          )}

          <div className="invalid-feedback">{errorMsg}</div>
        </div>
        {isPreviewImage === true ? (
          <div className="mb-3">
            <label className="form-label" style={previewLabelCustomStyle}>
              Image Preview
            </label>
            <img
              className="form-control"
              src={previewImage}
              style={previewImgCustomStyle}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default CSingleFileUpload;
